const CerbosResourceKinds = {
    ORGANIZATION: 'organization',
    PEOPLE: 'people',
    PROJECT: 'project',
    APPLICATION: 'application',
    SUBSCRIPTION: "subscription",
    TEAM: 'team'
};
const CerbosOrgActions = {
    CREATE_ORGANIZATION: 'create-organization',
    GET_ORGANIZATION: 'get-organization',
    UPDATE_ORGANIZATION: 'update-organization',
    DELETE_ORGANIZATION: 'delete-organization',
    GET_ORG_APPLICATION_LIST: 'get-organization-application-list',
    GET_ORG_PEOPLE_LIST: 'get-organization-people-list',
    GET_ORG_PROJECT_LIST: 'get-organization-project-list',
    GET_ORG_TEAM_LIST: 'get-organization-team-list',
    GET_ORGANIZATION_COUNTERS: 'get-organization-counters',
    UPDATE_ORGANIZATION_NAME: 'update-organization-name',
    UPDATE_ORGANIZATION_SETTINGS: 'update-organization-settings',
    CAN_MANAGE_PEOPLE: 'can-manage-people',
    CAN_MANAGE_OWNER: 'can-manage-owner',
    CAN_MANAGE_ALL: 'can-manage-all',
    CAN_UPDATE_TEAM: 'can-update-team',
    INVITE_PEOPLE: 'invite-people',
    CAN_INVITE_PEOPLE: 'can-invite-people',
    DELETE_PEOPLE: 'delete-people',
    UPDATE_PEOPLE: 'update-people',
    CAN_UPDATE_PEOPLE: 'can-update-people',
    GET_PROJECT: 'get-project',
    GET_APPLICATION: 'get-application',
    GET_TEAM: 'get-team',
    CREATE_PROJECT: 'create-project',
    GET_ORG_DEPLOYMENT_INTEGRATIONS: 'get-organization-deployment-integrations',
    UPDATE_ORG_DEPLOYMENT_INTEGRATIONS: 'update-organization-deployment-integrations'
};
const CerbosProjectActions = {
    CREATE_PROJECT: 'create-project',
    UPDATE_PROJECT: 'update-project',
    UPDATE_PROJECT_NAME: 'update-project-name',
    UPDATE_PROJECT_SETTINGS: 'update-project-settings',
    DELETE_PROJECT: 'delete-project',
    RESTORE_PROJECT: 'restore-project',
    GET_PROJECT_SETTINGS: 'get-project-settings',
    GET_CONTRIBUTOR_LIST: 'get-contributor-list',
    MANAGE_CONTRIBUTOR: 'manage-contributor',
    MANAGE_ALL_CONTRIBUTOR: 'manage-all-contributor',
    UPDATE_CONTRIBUTOR_ROLE: 'update-contributor-role',
    REMOVE_CONTRIBUTOR: 'remove-contributor'
};
const CerbosApplicationActions = {
    GET_APPLICATION_SETTINGS: 'get-application-settings',
    CREATE_APPLICATION: 'create-application',
    UPDATE_APPLICATION: 'update-application',
    UPDATE_APPLICATION_NAME: 'update-application-name',
    UPDATE_APPLICATION_SETTINGS: 'update-application-settings',
    DELETE_APPLICATION: 'delete-application'
};
const CerbosSubscriptionActions = {
    CAN_MANAGE_SUBSCRIPTION: "manage-subscription",
    GET_SUBSCRIPTION: "get-subscription"
};
const CerbosTeamActions = {
    CREATE_TEAM: 'can-update-team',
    DELETE_TEAM: 'delete-team'
};
const CerbosOrgKind = 'organization';
const CerbosPeopleKind = 'people';
const CerbosProjectKind = 'project';
const CerbosApplicationKind = 'application';
const CerbosSubscriptionKind = "subscription";
const CerbosTeamKind = 'team';
export { CerbosApplicationActions, CerbosApplicationKind, CerbosOrgActions, CerbosOrgKind, CerbosPeopleKind, CerbosProjectActions, CerbosProjectKind, CerbosResourceKinds, CerbosSubscriptionActions, CerbosSubscriptionKind, CerbosTeamActions, CerbosTeamKind };
